'use strict';

var React = require('react');

var StepIndicator  = require('js/screens/form/application-step-indicator.jsx'),
    QuestionError  = require('js/screens/form/application-question-error.jsx'),
    QuestionInput  = require('js/screens/form/application-question-input.jsx'),
    QuestionButton = require('js/screens/form/application-button.jsx');

var QuestionPage = React.createClass({

  propTypes: {
    question: React.PropTypes.shape({
      title: React.PropTypes.string.isRequired,
      fieldName: React.PropTypes.string.isRequired,
      type: React.PropTypes.number.isRequired,

      // list types
      list: React.PropTypes.arrayOf(React.PropTypes.string),

      // anything that can continue via. a trigger, like hitting Enter
      nextCallback: React.PropTypes.func,

      value: React.PropTypes.any
    }).isRequired,
    nextQuestionHandler: React.PropTypes.func.isRequired,
    prevQuestionHandler: React.PropTypes.func.isRequired,
    currentStep: React.PropTypes.number,
    stepCount: React.PropTypes.number,
    hasError: React.PropTypes.bool,
    stepsCompleted: React.PropTypes.number.isRequired,
  },

  render: function() {
    var backButton = null;
    if(this.props.currentStep > 0) {
       backButton = (
          <QuestionButton
            handler={this.props.prevQuestionHandler}
            modifier="back">
              <i className="fa fa-chevron-left QuestionButton-chevron QuestionButton-chevron--back"></i>
              <span>Back</span>
          </QuestionButton>
       );
    }

    return (
      <div key={this.props.currentStep} className="ApplicationQuestion">
        <div className="ApplicationQuestion-body">
          <QuestionInput
            {...this.props.question}
            nextCallback={this.props.nextQuestionHandler}
            hasError={this.props.hasError} />
          {backButton}
          <QuestionButton
            handler={this.props.nextQuestionHandler}>
            <span>Next</span>
            <i className="fa fa-chevron-right QuestionButton-chevron"></i>
          </QuestionButton>
        </div>
        <StepIndicator
          stepCount={this.props.stepCount}
          currentStep={this.props.currentStep}
          stepsCompleted={this.props.stepsCompleted} />
      </div>
    );
  }

});

module.exports = QuestionPage;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application-question-page.jsx
 **/